<bas-side-nav-hotlink
		*ngIf="activeMainItem()?.children?.length > 0"
		[items]="activeMainItem().children"
		[topLevel]="true"
></bas-side-nav-hotlink>
